/*
 * Чат на сайті з Ixi AI (до 06.10.2026 — Nadia), ШІ-помічницею WixMart (snippets/wixmart-nadia-chat.liquid).
 *
 * 07.10.2026: ВИДНО ВСІМ (запуск Ixi AI для клієнтів). `?nadia=0` — вимкнути в цьому браузері
 * (запамʼятовується), `?nadia=1` — повернути. До 07.10 було навпаки: лише з `?nadia=1`.
 *
 * Звʼязок з агентом — «прості» запити без кук: POST з text/plain (JSON у тілі) і GET
 * опитування. Розмова — за session_id у localStorage. Опитування: кожні 5 с з відкритою
 * панеллю, 20 с у фоні (лише видима вкладка) — нові відповіді дають червону крапку.
 * Текст відповідей — лише textContent; посилання http(s) робимо безпечними <a>.
 */
(function () {
  'use strict';

  var FLAG = 'wxm_nadia';
  var SID = 'wxm_nadia_sid';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      if (value === null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, value);
    } catch (e) { /* приватне вікно — працюємо без памʼяті */ }
    return null;
  }

  var qs = window.location.search;
  if (/[?&]nadia=1\b/.test(qs)) store(FLAG, null);
  if (/[?&]nadia=0\b/.test(qs)) store(FLAG, '0');
  if (store(FLAG) === '0') return;

  var root = document.getElementById('WxmNadia');
  if (!root) return;

  var TEXTS = {
    pl: {
      title: 'Ixi AI', badge: 'asystentka WixMart',
      sub: 'Odpowiada sztuczna inteligencja · możesz poprosić o człowieka',
      note: 'Rozmawiasz z asystentką AI sklepu WixMart. Wiadomości przetwarzamy, aby odpowiedzieć — ',
      privacy: 'polityka prywatności', placeholder: 'Napisz wiadomość…', menu: 'Czat z Ixi AI',
      typing: 'Ixi AI pisze…', error: 'Nie udało się wysłać. Spróbuj ponownie za chwilę.',
      close: 'Zamknij', send: 'Wyślij'
    },
    uk: {
      title: 'Ixi AI', badge: 'помічниця WixMart',
      sub: 'Відповідає штучний інтелект · можна попросити людину',
      note: 'Ви спілкуєтесь із ШІ-помічницею магазину WixMart. Повідомлення обробляємо, щоб відповісти — ',
      privacy: 'політика конфіденційності', placeholder: 'Напишіть повідомлення…', menu: 'Чат з Ixi AI',
      typing: 'Ixi AI пише…', error: 'Не вдалося надіслати. Спробуйте ще раз за хвилину.',
      close: 'Закрити', send: 'Надіслати'
    }
  };
  var lang = (root.getAttribute('data-lang') || 'pl').slice(0, 2) === 'uk' ? 'uk' : 'pl';
  var T = TEXTS[lang];
  var endpoint = root.getAttribute('data-endpoint');

  var list = root.querySelector('.wxm-nadia__list');
  var form = root.querySelector('.wxm-nadia__form');
  var input = root.querySelector('.wxm-nadia__input');
  var sendBtn = root.querySelector('.wxm-nadia__send');
  var typing = root.querySelector('.wxm-nadia__typing');
  var errorBox = root.querySelector('.wxm-nadia__error');

  root.querySelector('.wxm-nadia__title').textContent = T.title;
  var badge = document.createElement('span');
  badge.className = 'wxm-nadia__badge';
  badge.textContent = T.badge;
  root.querySelector('.wxm-nadia__title').appendChild(badge);
  root.querySelector('.wxm-nadia__sub').textContent = T.sub;
  var note = root.querySelector('.wxm-nadia__note');
  note.textContent = T.note;
  var privacyLink = document.createElement('a');
  privacyLink.href = root.getAttribute('data-privacy') || '/policies/privacy-policy';
  privacyLink.target = '_blank';
  privacyLink.rel = 'noopener';
  privacyLink.textContent = T.privacy;
  note.appendChild(privacyLink);
  note.appendChild(document.createTextNode('.'));
  input.placeholder = T.placeholder;
  input.setAttribute('aria-label', T.placeholder);
  sendBtn.setAttribute('aria-label', T.send);
  root.querySelector('.wxm-nadia__close').setAttribute('aria-label', T.close);
  typing.textContent = T.typing;
  errorBox.textContent = T.error;

  function newSid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'w' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  }
  var sid = store(SID);
  if (!sid || !/^[A-Za-z0-9-]{8,64}$/.test(sid)) { sid = newSid(); store(SID, sid); }

  var seen = {};
  var lastAt = null;
  var open = false;
  var waitingSince = 0;
  var timer = null;

  var URL_RE = /(https?:\/\/[^\s<>"')]+)/g;
  function renderText(el, text) {
    var parts = String(text || '').split(URL_RE);
    for (var i = 0; i < parts.length; i++) {
      if (i % 2 === 1) {
        var a = document.createElement('a');
        a.href = parts[i];
        a.target = '_blank';
        a.rel = 'noopener nofollow';
        a.textContent = parts[i];
        el.appendChild(a);
      } else if (parts[i]) {
        el.appendChild(document.createTextNode(parts[i]));
      }
    }
  }

  function addMessages(msgs) {
    var gotReply = false;
    for (var i = 0; i < (msgs || []).length; i++) {
      var m = msgs[i];
      if (!m || seen[m.id]) continue;
      seen[m.id] = true;
      var el = document.createElement('div');
      el.className = 'wxm-nadia__msg ' + (m.direction === 'inbound' ? 'wxm-nadia__msg--in' : 'wxm-nadia__msg--out');
      renderText(el, m.text);
      list.appendChild(el);
      if (!lastAt || m.sent_at > lastAt) lastAt = m.sent_at;
      if (m.direction !== 'inbound') gotReply = true;
    }
    if (gotReply) {
      waitingSince = 0;
      if (!open) setUnread(true);
    }
    typing.classList.toggle('is-on', waitingSince > 0 && Date.now() - waitingSince < 90000);
    list.scrollTop = list.scrollHeight;
  }

  function setUnread(on) {
    var targets = document.querySelectorAll('.wxm-chat__item--nadia, #WxmChatToggle');
    for (var i = 0; i < targets.length; i++) targets[i].classList.toggle('wxm-nadia-unread', on);
  }

  function poll() {
    if (document.hidden && !open) return schedule();
    var url = endpoint + '?session_id=' + encodeURIComponent(sid) + '&open=' + (open ? 'true' : 'false') +
      (lastAt ? '&after=' + encodeURIComponent(lastAt) : '');
    fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { if (data) addMessages(data.messages); })
      .catch(function () {})
      .then(schedule);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(poll, open || waitingSince ? 5000 : 20000);
  }

  // 07.10.2026 (власник): Ixi бачить кошик клієнта — знімок Shopify /cart.js з кожним повідомленням
  // (сервер тримає лише останній). Без кошика повідомлення все одно йде.
  function cartSnapshot() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || !c.items) return null;
        return {
          prices_in_cents: true,
          item_count: c.item_count,
          total_price: c.total_price,
          currency: c.currency,
          attributes: c.attributes || {},
          note: c.note || null,
          items: c.items.slice(0, 40).map(function (it) {
            return {
              title: it.product_title, variant_title: it.variant_title, quantity: it.quantity,
              price: it.price, final_line_price: it.final_line_price, sku: it.sku,
              product_type: it.product_type, vendor: it.vendor
            };
          })
        };
      })
      .catch(function () { return null; });
  }

  function send(text) {
    errorBox.classList.remove('is-on');
    sendBtn.disabled = true;
    // text/plain — «простий» запит без попереднього OPTIONS; JSON у тілі.
    return cartSnapshot().then(function (cart) {
      return fetch(endpoint, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ session_id: sid, text: text, cart: cart })
      });
    })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (data) {
        input.value = '';
        waitingSince = data.ai_handling ? Date.now() : 0;
        addMessages(data.messages);
        schedule();
      })
      .catch(function () { errorBox.classList.add('is-on'); })
      .then(function () { sendBtn.disabled = false; input.focus(); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (text && !sendBtn.disabled) send(text);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    }
  });

  function openPanel() {
    open = true;
    root.classList.add('is-open');
    setUnread(false);
    var menu = document.getElementById('WxmChat');
    if (menu) menu.classList.remove('wxm-chat--open');
    input.focus();
    poll();
  }
  function closePanel() {
    open = false;
    root.classList.remove('is-open');
    schedule();
  }
  root.querySelector('.wxm-nadia__close').addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) closePanel(); });

  // Пункт у плаваючому меню каналів (Instagram / Messenger / WhatsApp); немає меню — своя кнопка.
  var items = document.querySelector('#WxmChat .wxm-chat__items');
  var item = document.createElement('a');
  item.href = '#';
  item.className = 'wxm-chat__item wxm-chat__item--nadia';
  item.setAttribute('role', 'menuitem');
  item.setAttribute('aria-label', T.menu);
  item.innerHTML = '<span class="wxm-chat__label"></span><span class="wxm-nadia-dot"></span>' +
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2zm3 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm5 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/></svg>';
  item.querySelector('.wxm-chat__label').textContent = T.menu;
  item.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
  if (items) {
    items.insertBefore(item, items.firstChild);
    var fab = document.getElementById('WxmChatToggle');
    if (fab && !fab.querySelector('.wxm-nadia-dot')) {
      var dot = document.createElement('span');
      dot.className = 'wxm-nadia-dot';
      fab.appendChild(dot);
    }
  } else {
    item.style.cssText = 'position:fixed;right:20px;bottom:24px;z-index:9997;opacity:1;transform:none;';
    document.body.appendChild(item);
  }

  poll();
})();
